import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "./layout";
import PageMaintenance from "../templates/PageMaintenance";

const isMaintenanceActive = (value) => {
    return value === true || value === "true" || value === "1" || value === 1;
};

const MaintenanceGate = ({ children, props }) => {
    const data = useStaticQuery(graphql`
        {
            wp {
                acfThemeGeneralSettings {
                    aCFoptionTemplate {
                        groupMaintenance {
                            maintenanceActive
                        }
                    }
                }
            }
        }
    `);

    const maintenanceActive = data?.wp?.acfThemeGeneralSettings?.aCFoptionTemplate?.groupMaintenance?.maintenanceActive;

    if (isMaintenanceActive(maintenanceActive)) {
        return (<PageMaintenance props={props} />);
    }

    return (
        <Layout props={props}>
            {children}
        </Layout>
    );
};

export default MaintenanceGate;
